import script from "./VATReturnsTables.vue?vue&type=script&setup=true&lang=ts"
export * from "./VATReturnsTables.vue?vue&type=script&setup=true&lang=ts"

import "./VATReturnsTables.vue?vue&type=style&index=0&id=7248940f&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-7248940f"]])

export default __exports__